import { PropertyData } from '@/services/scraper.service';

export interface Coordinate {
  lat: number;
  lon: number;
}

export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  }).format(value);
}

export function removeDuplicatesByUrl(properties: PropertyData[]): PropertyData[] {
  return Array.from(
    new Map(properties.map(p => [p.url, p])).values()
  );
}

export function calculateCentroid(properties: PropertyData[]): Coordinate | null {
  const propsWithCoords = properties.filter(p => p.latitude && p.longitude);
  if (propsWithCoords.length === 0) return null;

  const sumLat = propsWithCoords.reduce((sum, p) => sum + (p.latitude || 0), 0);
  const sumLon = propsWithCoords.reduce((sum, p) => sum + (p.longitude || 0), 0);

  return {
    lat: sumLat / propsWithCoords.length,
    lon: sumLon / propsWithCoords.length,
  };
}
